// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";
import { isReactSnap } from "../utils/isReactSnap";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase only if config is valid
let app = null;
let db = null;
let analytics = null;

try {
  // Check if all required config values are present
  if (firebaseConfig.apiKey && firebaseConfig.projectId) {
    app = initializeApp(firebaseConfig);

    // Initialize Firestore only in browser environment
    // (react-snap 프리렌더링 중에는 실제 네트워크가 없어 Firestore/Analytics 연결이
    // 계속 재시도하다가 처리되지 않은 에러로 크래시하므로, 이 환경에서는 아예 건너뛴다)
    if (typeof window !== "undefined" && !isReactSnap()) {
      db = getFirestore(app);

      // Initialize Analytics (only if supported)
      isSupported().then((yes) => {
        if (yes) {
          analytics = getAnalytics(app);
        }
      });
    }
  }
} catch (error) {
  console.warn("Firebase initialization failed:", error);
}

export { db, analytics };
export default app;
